import React, { createContext, useContext } from 'react';

/**
 * How a route becomes a visible page — supplied by whichever shell is mounted,
 * since the tab manager and the v1 shell navigate differently.
 *
 * Lives beside the palette because the palette is its main consumer (a resource
 * row is a route), but it is not a palette concern: the shells provide it, and
 * anything that needs to navigate out of an action can read it.
 */
export type Navigator = (route: string) => void;

const NavigatorContext = createContext<Navigator | null>(null);

export const NavigatorProvider: React.FC<{
  children: React.ReactNode;
  navigator?: Navigator;
}> = ({ children, navigator }) => (
  <NavigatorContext.Provider value={navigator ?? null}>
    {children}
  </NavigatorContext.Provider>
);

/** Null when no shell has provided one — callers must handle that. */
export const useNavigator = (): Navigator | null =>
  useContext(NavigatorContext);
